import PropTypes from "prop-types";
import ColorPicker from "@/components/pickers/color-picker/color.picker.jsx";
import ColorPickerLabel from "@/components/pickers/color-picker/color-picker-label.jsx";

export default function GroupedColorPicker({
  bgColor,
  textColor,
  onChange,
  disableBackgroundColor = false,
  filterBG,
}) {
  const donationAmountColors = [
    "light-aqua",
    "light-green",
    "dark-green",
    "light-yellow",
    "dark-yellow",
    "medium-grey",
  ];

  function filterColors(color) {
    return donationAmountColors.includes(color);
  }

  return (
    <>
      <ColorPickerLabel
        color={bgColor}
        className={
          disableBackgroundColor
            ? "opacity-50 transition-opacity"
            : "opacity-100 transition-opacity"
        }
        labelText="Progress bar"
      />

      <ColorPicker
        currentColor={bgColor}
        fieldName="bgColor"
        disabled={disableBackgroundColor}
        onChange={onChange}
        filterFunction={filterBG}
      />
      <ColorPickerLabel color={textColor} labelText="Donation amount" className="mt-1" />

      <ColorPicker
        currentColor={textColor}
        fieldName="textColor"
        filterFunction={filterColors}
        onChange={onChange}
      />
    </>
  );
}

GroupedColorPicker.propTypes = {
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  onChange: PropTypes.func,
  disableBackgroundColor: PropTypes.bool,
  filterFunction: PropTypes.func,
};
